/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
function closeSubmenu(el){
  var subMenuActivated = "subMenuActivated";
  if(el.parent().parent().parent().hasClass(subMenuActivated)){
    el.parent().animate({
      right:'-100vw'
    }, 500, function(){
      el.parent().parent().parent().removeClass(subMenuActivated);
      el.remove();
    });

  }

}
(function($) {
  /*const player = document.querySelector("lottie-player");*/
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages script
    'common': {
      init: function() {

        // FAQ search engine
        $('#filterFAQ').on('keyup', function(){
          $(".card-header h3").each(function(){
            var val = $('#filterFAQ').val();

            if ($(this).is(':contains(' + val + ')') || $(this).closest('.card').find('.card-block p').is(':contains(' + val + ')')){
              $(this).closest('.card').show();
              if ($(this).closest('.accordionSection').find('.card:visible').length > 0){
                $(this).closest('.accordionSection').find('h3').show();
              }
            }else{
              $(this).closest('.card').hide();
              if ($(this).closest('.accordionSection').find('.card:visible').length === 0){
                $(this).closest('.accordionSection').find('h3').hide();
              }
            }
          });
        });

        if(!$('body').hasClass('page-template-template-contact-form')){
          $(document).ready(function() {



            var width = $(document).width();

            if ($('.bxslider').length > 0){
              if (width > 767){
                testimonialSlider = $('.bxslider').bxSlider({
                  auto: false,
                  autoControls: false,
                  controls:false,
                  touchEnabled: false,
                  pause: 1000
                });
              } else {
                testimonialSlider = $('.bxslider').bxSlider({
                  auto: false,
                  autoControls: false,
                  controls:false,
                  touchEnabled: true,
                  pause: 8000

                });
              }
            }

            /*    if ($('.logo_slider').length > 0){
                  if (width > 767){
                    logoSlider = $('.logo_slider').bxSlider({
                      auto: true,
                      autoControls: false,
                      maxSlides:3,
                      minSlides:3,
                      slideWidth:240,
                      moveSlides:1,
                      controls: false,
                      pause: 8000
                    });
                  }else{
                    logoSlider = $('.logo_slider').bxSlider({
                      auto: true,
                      autoControls: false,
                      maxSlides:1,
                      minSlides:1,
                      slideWidth:320,
                      moveSlides:1,
                      pause: 8000,
                      controls: false,
                      nextText:'<svg viewBox="0 0 451.846 451.847" style="enable-background:new 0 0 451.846 451.847;"><path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744   L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284   c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"/></svg>',
                      prevText:'<svg viewBox="0 0 451.846 451.847" style="enable-background:new 0 0 451.846 451.847;"><path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744   L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284   c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"/></svg>'
                    });
                  }
                }*/
            setTimeout(function(){
              if(typeof testimonialSlider !== 'undefined') {
                testimonialSlider.redrawSlider();
              }

            },500);

          });
        }


        // Open FAQ question if is in anchor
        var hash = window.location.hash.substr(1);
        /* if(hash.length > 0){
          $('#' + hash).closest('.card').find('.collapse').collapse('show');
        } */
        //Fixed bug
        if (hash.length > 0) {
          var element = $('#' + hash);
          if (element.length) {
              var card = element.closest('.card');
              var collapseElement = card.find('.collapse');
              if (collapseElement.length && typeof collapseElement.collapse === 'function') {
                  collapseElement.collapse('show');
              }
          }
        }


        // Fix anchor scroll on Firefox
        /* window.onload = function() {
          if (location.hash) {
            if(location.hash === '#contactModal') { return; }
            if(location.hash === "#etape2" || location.hash === "#etape1"){

            }
            var elId = location.hash.replace('#','');
            var scrollToEl = document.getElementById(elId);
            scrollToEl.scrollIntoView(true);
          }
        }; */



        var height = window.innerHeight - 35;
        var header = $('header.banner');
        var topHeader = 500;




        if (screen.width < 992) {
          if (screen.width  < 767) {
            if (navigator.userAgent.indexOf('Android') !== -1 ) {
              $("body").addClass("notSafari");

            }
          }

          // jQuery('.mobileMenu').height(height + 'px');
          var classHasChildren = 'menu-item-has-children';
          var closeSubMenu = 'close-sub-menu';


          $("."+classHasChildren + " > a").on('click', function(event){

            event.preventDefault();
            var subMenuActivated = "subMenuActivated";
            var nav = $(this).parent().parent();
            /**
             * && !$(this).find("ul > li:first-child").hasClass(closeSubMenu)
             */
            if(!nav.hasClass(subMenuActivated) ){
              var mainElement = "<li class='"+closeSubMenu+"' onclick='closeSubmenu(jQuery(this))'><a >"+$(this).html()+"</a></li>" ;
              /**
               * href='"+$(this).find(">a").attr("href")+"'
               */

              $(this).parent().find(".sub-menu").prepend(mainElement);
              nav.addClass(subMenuActivated);
              $(this).parent().find(".sub-menu").animate({
                right:0
              }, 500, function(){});
            }
            else{



            }
          });
          $('.responsiveMenu').on('click', function() {


            if (!$('body').hasClass('mobileActive')) {
              // $('.mobileMenu').css('display', 'flex');
              $('body').addClass('mobileActive');
              $(this).find(".hamburger").addClass("is-active");
              $('body').animate({
                right: "100vw",
              }, 500, function() {});
              /*player.play();*/
              $('#mobileSidebar').animate({
                right: "0",
              }, 500, function() {});
            }
            else {
              $(this).find(".hamburger").removeClass("is-active");

              var ulSubMenuActivated = $('#mobileSidebar ul.subMenuActivated');


              ulSubMenuActivated.find(".sub-menu").animate({
                right:'-100vw'
              }, 500, function(){
                closeSubmenu(ulSubMenuActivated.find('.'+closeSubMenu));

              });
              $('#mobileSidebar').animate({
                right: "-100vw",
              }, 500, function() {});
              /*player.stop();*/

              $('body').animate({
                right: "0",
              }, 500, function() {
                $('body').removeClass('mobileActive');

              });
            }
          });

          $('.mobileBottom .votre').on('click', function(){
            $('.responsiveMenu').click();
          });

          $(window).scroll(function (event) {
            var yCoord = $(this).scrollTop();


            if(yCoord > 0 && !$('body').hasClass('scrollActivated')){
              $('body').addClass('scrollActivated');
              /* player.play();*/

            }
            else if(yCoord === 0 && $('body').hasClass('scrollActivated')){
              $('body').removeClass('scrollActivated');
              /* player.stop();*/
            }

          });

        } else {

          $(window).scroll(function (event) {
            var yCoord = $(this).scrollTop();


            if(yCoord > 1 && !$('body').hasClass('scrollActivated')){
              $('body').addClass('scrollActivated');

              /* player.play();*/

            }
            else if(yCoord <= 1 && $('body').hasClass('scrollActivated')){
              $('body').removeClass('scrollActivated');
              /*player.stop();*/
            }

          });

          if ($('.stickySidebar').length){
            var stickyHeight = $('.stickySidebar').height();
            var numItems = $('.archivePost').length;
            if ((numItems >= 2) || ($('.blogPost').length === 1)){
              $('.stickySidebar').addClass('absolute');
              $('.stickySidebar').width($('.sidebarContent').width());
              var sidebar = $('.stickySidebar');
              var top = sidebar.offset().top - parseFloat(sidebar.css('margin-top'));
              var dif = $(document).height() - $('#footer').height() - $('.stickySidebar').height() - 100;

              $(window).scroll(function (event) {
                var y = $(this).scrollTop();
                if (y >= top) {
                  sidebar.addClass('fixed');
                } else {
                  sidebar.removeClass('fixed');
                }
                if ($(window).scrollTop() <= dif){
                  sidebar.removeClass('bottomAbsolute');
                } else {
                  sidebar.addClass('bottomAbsolute');
                }
              });
            }
          }
        }

        if (screen.width < 992) {

          $('.input-group-addon').on('click', function(){
            var offset = $(".searchIcon").offset();
            var minusOffset = -1 * offset.left;
            $( window ).resize(function() {
              var offset = $(".searchIcon").offset();
              var minusOffset = -1 * offset.left;
            });
            if ($('.sidebar-search').hasClass('activeSearch')){
              $('.sidebar-search').css('width', '100%').css('margin-left', 0);
            }else{
              $('.sidebar-search').css('width', offset.left).css('margin-left', minusOffset);
            }
            $('.sidebar-search').toggleClass('activeSearch');
            $(this).toggleClass('activeZoom');
          });
        } else {
          $('.footerBlock > a').on('click', function(e){
            e.preventDefault();
          });
          if ($('#plusMenuDropdown').length){
            var width = ($('#plusMenuDropdown').width()/2 - 4)* -1;
            $('.categories .plusMenu').css('margin-left', width);
          }
        }

        if ($('#commentform').length){
          $('#commentform .col-xs-12 input').val('');
        }

        /*Open dropdown on hover*/
        $('.plusDropdown .plus-to-minus, #plusMenuDropdown').hover(function() {
          $('#plusMenuDropdown').stop(true, true).delay(100).fadeIn(300);
        }, function() {
          $('#plusMenuDropdown').stop(true, true).delay(100).fadeOut(300);
        });



        /*Cookie notice*/
        function getCookieValue(a) {
          var b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
          return b ? b.pop() : '';
        }

        if(getCookieValue("acceptOfficeoCookie") !== "1") {
          $('.cookies').css('display', 'block');
          $('#tawkchat-container').addClass("bottom140");
        }
        else{
          $('#tawkchat-container').addClass("bottom60");
        }

        $('.closeCookie').on('click', function(e){
          e.preventDefault();
          document.cookie = "acceptOfficeoCookie=1;path=/";
          $('.cookies').css('display', 'none');
          $('#tawkchat-container').addClass("bottom60");
          console.log("chat height: " + $('.cookies').height() + " when cookie clicket to close" );
        });

        /*Input placeholder*/
        $('form').find('input, textarea').focus(function() {
          $(this).parent('.inputBlock').find('label').animate({
            'top': '5px',
            'fontSize': '13px',
            'opacity': '0'
          }, 300, 'swing', function() {
            $(this).hide();
          });
        });

        $('form').find('input, textarea').blur(function() {
          if ($(this).val().length === 0) {
            $(this).parent().find('label:not(".transparentButton")').show();
            $(this).parent().find('label:not(".transparentButton")').animate({
              'top': '10px',
              'fontSize': '18px',
              'opacity': '1'
            }, 300);
          }
        });

        var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        if (iOS) {
          $('.mobileBlogMenu').on( "click touchstart", function() {
            return true;
          });
          $('#blogSearch input').css('width', '0px');
          $('#blogSearch input').css('padding-left', '60px');
          $('#blogSearch button').css('margin-right', '0px');
        }

        $('#blogSearch').on('submit', function(e){
          if ($('.sidebar-search').val() === ''){
            e.preventDefault();
          }
        });

        $('.openModalSidebar').click(function() {
          $('.modal')
            .prop('class', 'modal fade') // revert to default
            .addClass( $(this).data('direction') );
          $('.modal').modal('show');
        });

        $('#selectPopup').selectpicker();
        $('#selectPopupReferral').selectpicker();
        $('#homeSelect').selectpicker();

        $('#commentform, #sidebarForm').on('submit', function(e){
          e.preventDefault();
          $(this).find('.required').removeClass('invalidRequired');
          $(this).find('label').removeClass('invalidLabel');
          $(this).find('.closeWarning').fadeOut('fast');
          $(this).find('.required').each(function(){
            if ($(this).val() === ''){
              $(this).addClass('invalidRequired');
              $(this).siblings('label').addClass('invalidLabel');
              $(this).siblings('.closeWarning').fadeIn('fast');

            }
          });
        });

        function changeStep(step, removeCLass){
          $("body").addClass(step);
          $("body").removeClass(removeCLass);
        }

        function validatePhone(phone) {
          var re = /^(?:(?:\+|00)\d{1,3}[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/;
          if(re.test(phone)){
            return true;
          }
          re10 = /^\d{10,}$/;

          return re10.test(phone);
        }

        function validateEmail(email) {
          var re = /\S+@\S+\.\S+/;
          return re.test(email);
        }
        function verifyFields($, section){
          var sectionValidated = 1;
          $(section).find(".required").each(function(index){

            var field = $(this);

            if(!field.hasClass('cp')){
              if(field.val() === ''){
                field.addClass("notValidated");
                sectionValidated = 0;
              }
            }
            if(field.attr('id') === 'phone' && !validatePhone(field.val())) {
              sectionValidated = 0;
            }
            if(field.attr('id') === 'email' && !validateEmail(field.val())) {
              sectionValidated = 0;
            }
          });

          $(section).data("validated", sectionValidated);
          return sectionValidated;
        }


        $('#sidebarForm input, .rightBlock form input, #commentform input, .form-template form input, .form-template form textarea').blur(function(){
          if($(this).hasClass('invalidRequired') && $(this).val() !== ''){
            $(this).removeClass('invalidRequired');
            $(this).siblings('label').removeClass('invalidLabel');
            $(this).siblings('.closeWarning').fadeOut('fast');
          }
        });

        $('.form-template form input[type=file]').on('change', function(){
          if ($(this).get(0).files.length !== 0) {
            $('.formFileButton').removeClass('fileSubmitInvalid').removeClass('invalidLabel');
            $('#cvUpload').removeClass('invalidRequired');
          }
        });

        /*$('#sidebarForm').on('submit', function(e){

          $(this).find('.required').removeClass('invalidRequired');
          $(this).find('label').removeClass('invalidLabel');
          $(this).find('.closeWarning').fadeOut('fast');
          $(this).find('.required').each(function(){
            if ($(this).val() === ''){
              $(this).addClass('invalidRequired');
              $(this).siblings('label').addClass('invalidLabel');
              $(this).siblings('.closeWarning').fadeIn('fast');
              e.preventDefault();
            }
          });
        });*/
        function lockTime(select){
          var LoopIndex = 0;
          if($('.currentDate').data('min') !== '00' ) {
            var currentMinOption =$('#flatpickr-minuteselect option[value='+$('.currentDate').data('min')+'min]');
            LoopIndex = currentMinOption.index();
            for(let i = 0; i < LoopIndex; i++){
              let nextEl = currentMinOption.prev();
              nextEl.attr('disabled', 'disabled');
              currentMinOption = nextEl;
            }
          }
          if($('.currentDate').data('hour') !== '09' ) {

            var currentHourOption = $('#flatpickr-hourselect option[value='+$('.currentDate').data('hour')+'h]');
            var LoopHourIndex = currentHourOption.index();

            for(let i = 0; i < LoopHourIndex; i++){
              let prev = currentHourOption.prev();
              prev.attr('disabled', 'disabled');
              currentHourOption = prev;
            }
          }
        }
        function unlockTime(select){
          select.find('option').each(function(){
            $(this).removeAttr('disabled');
          });
        }

        $('.rightBlock form').on('submit', function(e){

          e.preventDefault();
          $(this).find('.required').removeClass('invalidRequired');
          $(this).find('label').removeClass('invalidLabel');
          $(this).find('.closeWarning').fadeOut('fast');
          $(this).find('.required').each(function(){
            if ($(this).val() === ''){
              $(this).addClass('invalidRequired');
              $(this).siblings('label').addClass('invalidLabel');
              $(this).siblings('.closeWarning').fadeIn('fast');


            }
          });
          //All required fields filled
          if ($(this).find('.invalidRequired').length === 0){

            var sendData = new FormData(this);
            $('.rightBlock .inputBlock input').val("");
            $('.rightBlock .inputBlock textarea').val("");
            $('.rightBlock span.filter-option').text('Quand souhaitez-vous être rappelé?');
            $.magnificPopup.open({
              items: {
                src: '#successMessage'
              },
              callbacks: {
                close : function() {
                  location.reload();
                }
              },
              type: 'inline',
              showCloseBtn: false
            });
            $( "label" ).each(function( index ) {
              $(this).show();
              $(this).animate({
                'top': '10px',
                'fontSize': '18px',
                'opacity': '1'
              }, 300, 'swing');
            });

            var functionRequest = $(this).find('[name="action"]').val();
            $.ajax({
              type:"POST",
              url: '/wp-admin/admin-ajax.php',
              action: functionRequest,
              contentType: false,
              cache: false,
              processData:false,
              data: sendData,
              success:function(response){
                $('#successMessage').append(response.data);
                grecaptcha.reset($(this).find('.g-recaptcha').data('rID'));
                $(this).find('.required').removeClass('invalidRequired');
                $(this).find('label').removeClass('invalidLabel');
                $(this).find('.closeWarning').fadeOut('fast');
              },
              error: function (error){
                console.log(error);
                grecaptcha.reset($(this).find('.g-recaptcha').data('rID'));
              },
            });
          }
          else{
            grecaptcha.reset($(this).find('.g-recaptcha').data('rID'));
          }

        });

        if($('body').hasClass('page-template-template-contact-form-php')){
          $('.notValidated').on("mouseenter focus change keyup keydown keypress", function(){
            if($(this).hasClass('notValidated')){
              $(this).removeClass('notValidated');
            }
          });
          $('.form-template-contact form .required').on("blur change", function(){
            if($(this).val() === ""){
              $(this).addClass("notValidated").removeClass("validatedFields");
            }
            else{
              if($(this).attr("type") === 'email'){
                if(!validateEmail($(this).val())){
                  $(this).addClass("notValidated").removeClass("validatedFields");
                  return "";
                }
              }
              if($(this).attr('id') === 'phone'){
                if(!validatePhone($(this).val())){
                  $(this).addClass("notValidated").removeClass("validatedFields");
                  return "";
                }
              }
              $(this).removeClass("notValidated").addClass("validatedFields");
            }
          });

          $('.back-icon-etape1').click(function(e){
            changeStep("etape1", "etape2");
          });

          $('.resetDate').on('click', function(){
            $('.date-time.form-control').val("");
            $('.callDate').val('');
            $('.callTime').val('');
          });

          $('.date-time.form-control').on("click focus",function(){
            $(this).hide();
            $('.pickdate.form-control').show();
            $('.pickdate.form-control').focus();
          });


          if(!CONTACT_FORM.opening_time){

            var disableDates = JSON.parse($(".excludedDates").val());

            var pickdateOptions = {
              onClose: function (selectedDates, dateStr, instance){

                $('.callDate').val(dateStr.replace(/ \d+\:\d+/, ''));
                $('.callTime').val(dateStr.replace(/\d+\-\d+-\d+ /, ''));

                $('.date-time.form-control').val(instance._input.value);
                $('.pickdate.form-control').hide();
                $('.date-time.form-control').show();

                $('.flatpickr-calendar-layer').removeClass('show');
                $('.wrapper-blur').removeClass('blur');
              },
              onOpen: function(selectedDates, dateStr, instance) {
                $('.flatpickr-calendar-layer').addClass('show');
                $('.wrapper-blur').addClass('blur');
              },
              onReady: function (selectedDates, dateStr, instance){
                lockTime();
              },
              onChange: function(selectedDates, dateStr, instance){

                let chosenDay = selectedDates[0].getDate();
                let chosenHour = selectedDates[0].getHours();
                let chosenMin = selectedDates[0].getMinutes();
                let chosenMonth = selectedDates[0].getMonth();
                if(chosenMin === 0){
                  chosenMin = "00";
                }

                if($('.currentDate').data('day') !== chosenDay || ($('.currentDate').data('day') === chosenDay && $('.currentDate').data('month') !== chosenMonth)){
                  unlockTime($('#flatpickr-hourselect'));
                  unlockTime($('#flatpickr-minuteselect'));
                }
                else{
                  /*console.log("change date");
                  console.log(chosenDay + " " + chosenHour + " : " + chosenMin);*/

                 /* console.log(chosenHour);
                  console.log(chosenMin);*/

                  lockTime();
                  $('#flatpickr-hourselect').val(chosenHour+'h');
                  $('#flatpickr-minuteselect').val(chosenMin+'min');


                  if($('.currentDate').data('hour') !== chosenHour){
                    unlockTime($('#flatpickr-minuteselect'));
                  }
                  else{
                    var indexCurrentMin = $('#flatpickr-minuteselect option[value='+chosenMin+'min]').index();
                    var indexCurrentDateMin = $('#flatpickr-minuteselect option[value='+$('.currentDate').data('min')+'min]').index();
                    if(indexCurrentDateMin > indexCurrentMin){
                      $('#flatpickr-minuteselect').val($('.currentDate').data('min')+'min');
                      $(".flatpickr-minute").val($('.currentDate').data('min'));
                    }
                  }
                }
              },
              enableTime: true,
             plugins : [new ConfirmDatePlugin({
               confirmIcon: "", // your icon's html, if you wish to override
               confirmText: "Appliquer ",
               showAlways: true,
               theme: "light" // or "dark"
             })],
              altFormat: "d/m/Y à H\\hi",
              dateFormat: "Y-m-d H:i",
              altInput: true,
              minDate: $('.currentDate').val(),
              minuteIncrement: 15,
              defaultDate: $('.currentDate').val(),

              defaultHour: "9",
              minTime: "09:00",
              maxTime: "19:00",
              disable: [
                function(date) {
                  return (date.getDay() === 0 || date.getDay() === 6);
                }
              ].concat(disableDates),

              locale: {
                "firstDayOfWeek": 1,
                "weekdays": {
                  shorthand: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
                  longhand: [
                    "dimanche",
                    "lundi",
                    "mardi",
                    "mercredi",
                    "jeudi",
                    "vendredi",
                    "samedi",
                  ],
                },

                "months": {
                  shorthand: [
                    "janv",
                    "févr",
                    "mars",
                    "avr",
                    "mai",
                    "juin",
                    "juil",
                    "août",
                    "sept",
                    "oct",
                    "nov",
                    "déc",
                  ],
                  longhand: [
                    "janvier",
                    "février",
                    "mars",
                    "avril",
                    "mai",
                    "juin",
                    "juillet",
                    "août",
                    "septembre",
                    "octobre",
                    "novembre",
                    "décembre",
                  ],
                },


                rangeSeparator: " au ",
                weekAbbreviation: "Sem",
                scrollTitle: "Défiler pour augmenter la valeur",
                toggleTitle: "Cliquer pour basculer",
                time_24hr: true,
              },
              time_24hr: true
            };




            var calendar = $(".pickdate").flatpickr(pickdateOptions);

            $("#flatpickr-hourselect").on("change", function(){
              let h = $(this).find(":selected").text();
              if(h === "19h"){
                $("#flatpickr-minuteselect").val("00min");
                $("#flatpickr-minuteselect").attr("disabled", "disabled");
              }
              if(h !== "19h"){
                $("#flatpickr-minuteselect").removeAttr("disabled");
              }
              $(".flatpickr-hour").val(h.replace(/h/, ''));
            });

            $("#flatpickr-minuteselect").on("change", function(){
              let h = $(this).find(":selected").text();
              $(".flatpickr-minute").val(h.replace(/min/, ''));
            });
          }


          /* $("#etape1-btn").click(function(e){
            e.preventDefault();

            if(verifyFields($,"#etape1")){
              location.hash = "etape2";

              $('#etape2 .name').html($('#nom').val());
              $('#etape2 .prefix').html($('#selectCivility').find(":selected").text());

              changeStep("etape2");
            }
          }); */

          $('#sendContactForm').on('click', function(e){
            e.preventDefault();



            if(verifyFields($,"#etape1") && verifyFields($,"#etape2")){
              var functionRequest = $(".contact-form-v2 [name='action']").val();
              var sendData = new FormData($(".contact-form-v2")[0]);

              if($(window).width() < 500){
                $('.legal').hide();
                $('body').addClass('bodyFixed');
                window.scrollTo(0, 0);
              }


              $.magnificPopup.open({
                items: {
                  src: '#successCustomContact'
                },
                callbacks: {
                  close : function() {
                    window.location.href = '/';
                  }
                },
                type: 'inline',
                showCloseBtn: false
              });

              $.ajax({
                type: "POST",
                url: '/wp-admin/admin-ajax.php',
                action: functionRequest,
                contentType: false,
                cache: false,
                processData: false,
                data: sendData,
                success: function (response) {

                },
                error: function (error) {

                  console.log(error);
                }
              });
            }
          });

          $("#effectifGroupe").change( function(){
            var selectedValue = $(this).find(":selected").text();
            var jobRole = $("#jobRole");

            if (selectedValue === "ETI (250-4999 salariés)" || selectedValue === "GE (5000+ salariés)") {
              jobRole.removeClass("hide");
            }
            else{
              jobRole.addClass("hide");
              jobRole.val("");
            }
          });
        }



        $('input:radio').change(function(){
          $(this).closest('.checkboxBlock').find('label').removeClass('radioChecked');
          $(this).siblings('label').addClass('radioChecked');
        });

        $('.form-template form').on('submit', function(e){
          e.preventDefault();
          $(this).find('.required').removeClass('invalidRequired');
          $(this).find('label').removeClass('invalidLabel fileSubmitInvalid');
          $(this).find('.closeWarning').fadeOut('fast');
          invalidID = false;
          $(this).find('.required').each(function(){
            if (($(this).val() === '') && ($(this).attr('id') !== 'cvLabel')){
              if (!invalidID) {
                invalidID = true;
                $('html,body').animate({
                  scrollTop: $('#' + $(this).attr('id')).offset().top - 60
                });
              }
              $(this).addClass('invalidRequired');
              $(this).siblings('label').addClass('invalidLabel');
              $(this).siblings('.closeWarning').fadeIn('fast');
              /*grecaptcha.reset($(this).find('.g-recaptcha').data('rID'));*/
            }
          });
          if ($('#cvUpload').get(0).files.length === 0){
            $('.formFileButton').addClass('fileSubmitInvalid');
            $('#cvUpload').addClass('invalidRequired');
          }
          else{
            $('.formFileButton').removeClass('fileSubmitInvalid').removeClass('invalidLabel');
            $('#cvUpload').removeClass('invalidRequired');
          }
          //All required fields filled
          if ($(this).find('.invalidRequired').length === 0) {
            var sendData = new FormData(this);
            $('.form-template form input').val('');
            $('.form-template form textarea').val('');
            $('.fileName').text('Aucun fichier choisi');
            $("input[type='radio']").attr("checked", false);
            $("input[type='radio']").prop("checked", false);
            $("input[type='radio']").removeAttr("checked");
            $("label").removeClass("radioChecked");
            $('.formFileButton').removeClass('fileSubmitInvalid');

            $.magnificPopup.open({
              items: {
                src: '#successCustomContact'
              },
              callbacks: {
                close : function() {
                  location.reload();
                }
              },
              type: 'inline',
              showCloseBtn: false
            });

            var functionRequest = $(this).find('[name="action"]').val();
            $.ajax({
              type: "POST",
              url: '/wp-admin/admin-ajax.php',
              action: functionRequest,
              contentType: false,
              cache: false,
              processData: false,
              data: sendData,
              success: function (response) {
                /*grecaptcha.reset($(this).find('.g-recaptcha').data('rID'));*/
              },
              error: function (error) {
                /*grecaptcha.reset($(this).find('.g-recaptcha').data('rID'));*/
                /*console.log(error);*/
              }
            });
          }
        });

        $('.closeWarning').on('click', function(){
          $(this).siblings('input, textarea').removeClass('invalidRequired');
          $(this).siblings('label').removeClass('invalidLabel');
          $(this).fadeOut('fast');
        });

        // Inline popups .heroBox,
        $(' .conformiteAction, .votreBlock, .atid, .grandeBlock, .conPopupLink, .sidebarPopupBtn').magnificPopup({
          delegate: 'a',
          showCloseBtn: false,
          removalDelay: 500,
          callbacks: {
            beforeOpen: function() {
              this.st.mainClass = this.st.el.attr('data-effect');
            }
          },
          midClick: true
        });

        $("a[href$='#contactModal']").on('click', function(e){
          e.preventDefault();
          window.location.href = '/contact/?utm_hyperef=x';
        });

        // Contact modal custom links
       /* $("a[href$='#contactModal']").magnificPopup({
          showCloseBtn: false,
          removalDelay: 500,
          callbacks: {
            beforeOpen: function() {

              $('.responsiveMenu .hamburger.is-active').click();

              this.st.mainClass = this.st.el.attr('data-effect') || 'mfp-zoom-in';
            }
          },
          midClick: true
        });*/

        $('.custom-pageImgBlock a').on('mouseover click', function(){
          $(this).find('.customOverlay').addClass('customCurrentOverlay');
        });
        $('.custom-pageImgBlock a').on('mouseleave', function(){
          $(this).find('.customOverlay').removeClass('customCurrentOverlay');
        });



        $('.closeModal, .closeSuccess').on( "click", function(e) {
          e.preventDefault();
          if($(this).hasClass('goHome')){
            window.location.href = "/";
          }
          $.magnificPopup.close();
          location.reload();
        });

        $('.mfp-container, .mfp-wrap, .mfp-bg').on("click", function(e) {
          e.preventDefault();
          location.reload();
        });

        $('.faq-page').on('show.bs.collapse', '.collapse', function (e) {
          $(e.target).siblings('.card-header').addClass('card-bordered');
        });
        $('.faq-page').on('hidden.bs.collapse', '.collapse', function (e) {
          $(e.target).siblings('.card-header').removeClass('card-bordered');
        });

        $('.faq-page').on('shown.bs.collapse hidden.bs.collapse', '.collapse', function (e) {
          $(e.target).siblings('.card-header').find('.plus-to-minus').toggleClass('minus');
        });

        $('.currentArchivePage a').click(function(e){
          e.preventDefault();
        });

        $('.bloc-collapsible').hide();

        // expand button
        $('.bloc-bottom').click(function(event){
          if(!$(event.target).parents().hasClass('bloc-collapsible')) {
            var element = $(event.target).closest('.bloc-bottom');
            //collapse block
            var collapsibleBlock = element.children('.bloc-collapsible');
            collapsibleBlock.toggle();

            //rotate indicator
            element.children('.expand-button').toggleClass("rotate");
          }
        });

        // Fire global agencies tags
        window.fireAgenciesTags = function () {
          var query = window.location.search;

          if (query.indexOf('agency-id=355945') !== -1) {
            obApi('track', 'Lead Outbrain');
          }

          if (query.indexOf('agency-id=355950') !== -1) {
            twttr.conversion.trackPid('o0jev', { tw_sale_amount: 0, tw_order_quantity: 0 });
          }

          if (query.indexOf('agency-id=356586') !== -1 || query.indexOf('agency-id=360912') !== -1) {
            window.uetq = window.uetq || [];
            window.uetq.push ('event', 'Envoi', {event_category: 'Formulaire client LP'});
          }
        };

        // Open contact popup on #contactModal anchor
        $( document ).ready(function() {
          if(window.location.hash && window.location.hash === '#contactModal') {
            window.location.href = '/contact/?utm_hyperef=x';
            //$.magnificPopup.open({ items: { src: '#contactModal' } }, 0);
          }
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home template script
    'home': {
      init: function() {
        setTimeout(function(){
          var maxHeight = Math.max.apply(null, $(".countDesc").map(function ()
          {
            return $(this).height();
          }).get());
          $('.countDesc').height(maxHeight);
        }, 1);

        $('.playButton').on('click', function(ev){
          $('.playVideo iframe')[0].src += "&autoplay=1";
          $('.videoOverlay').fadeOut('slow');
          $(this).fadeOut('slow');
        });

      },
      finalize: function() {

      }
    },
    // Page template referral script
    'page_template_template_referral': {
      init: function() {
        // copy button
        $('#copy-button').click(function(){
          var inputField = $('#referral-link');
          inputField.select();
          document.execCommand('copy');
          $('#copy-button').html('Copié!');
        });

        // facebook share
        $('#facebookButton').click(function () {
          var shareLink = $('#referral-link').val();
          FB.ui({
            method: 'share',
            display: 'popup',
            href: shareLink,
            title: '1h offerte',
            picture: 'https://officeopro.com/wp-content/uploads/2017/03/pop-up-facebook.png',
            description: 'Faites comme moi, adoptez la libération administrative de votre entreprise, sans embauche.',
          }, function(response){});
        });



        //email validation
        function validateEmail(email) {
          var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
          return re.test(email);
        }

        function updateMultiInputValue(origField, list) {
          var mailList = '';
          list.children().each(function () {
            mailList += $(this).children('span').html() + ',';
          });
          origField.val(mailList.slice(0,-1));
        }

        // multiple input field component
        $.fn.multipleInput = function() {
          return this.each(function() {
            // list of email addresses as unordered list
            $list = $('<ul/>');
            //current placeholder
            var placeholder= $(this).attr('placeholder');
            var origField = $(this);
            // input
            var $input = $('<input placeholder="'+placeholder+'" type="email" id="email_search" class="email_search multiemail"/>').keyup(function(event) {
              if(event.which === 13 || event.which === 32 || event.which === 188) {
                var val;
                if(event.which === 188){
                  val = $(this).val().slice(0, -1);// remove space/comma from value
                }
                else{
                  val = $(this).val(); // key press is space or comma
                }
                if(validateEmail(val)){
                  // append to list of emails with remove button
                  $list.append($('<li class="multipleInput-email"><span>' + val + '</span></li>')
                    .append($('<a href="#" class="multipleInput-close" title="Remove"></a>')
                      .click(function(e) {
                        $(this).parent().remove();
                        updateMultiInputValue(origField, $list);
                        e.preventDefault();
                      })
                    )
                  );
                  // empty input
                  $(this).val('');
                  updateMultiInputValue(origField, $list);
                }
                else{
                  alert('Cette adresse email est invalide');
                }
              }
            });

            $input.on('blur', function(event) {
              if($input.val().length > 2) {
                var e = jQuery.Event("keyup");
                e.which = 32;
                $input.trigger(e);
              }
            });

            // container div
            var $container = $('<div class="multipleInput-container" />').click(function() {
              $input.focus();
            });
            // insert elements into DOM
            $container.append($list).append($input).insertAfter($(this));
            return $(this).hide();
          });
        };

        // init the multiple input field
        $('#destEmails').multipleInput();

        // disable enter to submit
        $('#referralForm').on('keyup keypress', function(e) {
          var keyCode = e.keyCode || e.which;
          if (keyCode === 13) {
            e.preventDefault();
            return false;
          }
        });

        // empty the custom field upon submit
        $('#sendReferralMails').click(function(){
          $('.multipleInput-container').children('ul').html('');
        });
      }
    },
    // Page template recruiting script
    'page_template_template_recruiting': {
      init: function() {
        var width = $(document).width();

        if (width > 767) {
          $('.bxslider').bxSlider({
            mode: 'horizontal',
            moveSlides: 1,
            slideMargin: 0,
            infiniteLoop: true,
            touchEnabled: false,
            slideWidth: 0,
            minSlides: 1,
            maxSlides: 1,
            speed: 800,
            pause: 8000,
            wrapperClass: 'customWrapper bx-wrapper',
            adaptiveHeight: true,
            controls: false,
            auto: true,
          });
        } else {
          $('.bxslider').bxSlider({
            mode: 'horizontal',
            moveSlides: 1,
            slideMargin: 0,
            infiniteLoop: true,
            touchEnabled: true,
            slideWidth: 0,
            minSlides: 1,
            maxSlides: 1,
            speed: 800,
            pause: 8000,
            wrapperClass: 'customWrapper bx-wrapper',
            adaptiveHeight: true,
            controls: false,
            auto: false,
          });
        }
      }
    },
    // Page template comparatif scripts
    'page_template_template_comparatif': {
      init: function() {
        var width = $(document).width();

        if (width > 767) {
          $('.bxslider').bxSlider({
            mode: 'horizontal',
            moveSlides: 1,
            slideMargin: 0,
            infiniteLoop: true,
            touchEnabled: false,
            slideWidth: 0,
            minSlides: 1,
            maxSlides: 1,
            speed: 800,
            pause: 8000,
            wrapperClass: 'customWrapper bx-wrapper',
            adaptiveHeight: true,
            controls: false,
            auto: true,
          });
        } else {
          $('.bxslider').bxSlider({
            mode: 'horizontal',
            moveSlides: 1,
            slideMargin: 0,
            infiniteLoop: true,
            touchEnabled: true,
            slideWidth: 0,
            minSlides: 1,
            maxSlides: 1,
            speed: 800,
            pause: 8000,
            wrapperClass: 'customWrapper bx-wrapper',
            adaptiveHeight: true,
            controls: false,
            auto: false,
          });
        }
      }
    },
    // Page template contact scripts
    'page_template_template_contact': {
      init: function() {
        // Sliders
        $('.bxslider').bxSlider({
          mode: 'horizontal',
          moveSlides: 1,
          slideMargin: 0,
          infiniteLoop: true,
          slideWidth: 0,
          minSlides: 1,
          maxSlides: 1,
          speed: 800,
          pause: 8000,
          wrapperClass: 'customWrapper bx-wrapper',
          adaptiveHeight: true,
          controls: true,
          auto: true,
          pager: false,
          prevText: '',
          nextText: '',
          autoStart: false,
          touchEnabled: $('.bxslider > div').length> 1,
        });

        // Form
        $('.form-template-contact form').on('submit', function(e){
          e.preventDefault();
          $(this).find('.required').removeClass('invalidRequired');
          $(this).find('label').removeClass('invalidLabel fileSubmitInvalid');
          $(this).find('.closeWarning').fadeOut('fast');
          invalidID = false;
          $(this).find('.required').each(function(){
            if (($(this).val() === '') && ($(this).attr('id') !== 'cvLabel')){
              if (!invalidID) {
                invalidID = true;
                $('html,body').animate({
                  scrollTop: $('#' + $(this).attr('id')).offset().top - 60
                });
              }
              $(this).addClass('invalidRequired');
              $(this).siblings('label').addClass('invalidLabel');
              $(this).siblings('.closeWarning').fadeIn('fast');
            }
          });

          //All required fields filled
          if ($(this).find('.invalidRequired').length === 0) {
            var email = $('#email').val();
            var sendData = new FormData(this);
            $('.form-template-contact form input').val('');
            $('.form-template-contact form textarea').val('');
            $(".form-template-contact form select").prop('selectedIndex', 0);
            $('.fileName').text('Aucun fichier choisi');
            $("input[type='radio']").attr("checked", false);
            $("input[type='radio']").prop("checked", false);
            $("input[type='radio']").removeAttr("checked");
            $("label").removeClass("radioChecked");
            $('.formFileButton').removeClass('fileSubmitInvalid');

            $.magnificPopup.open({
              items: {
                src: '#successCustomContact'
              },
              callbacks: {
                close : function() {
                  location.reload();
                }
              },
              type: 'inline',
              showCloseBtn: false
            });

            var query = window.location.search;

            var functionRequest = $(this).find('[name="action"]').val();

            $.ajax({
              type: "POST",
              url: '/wp-admin/admin-ajax.php',
              action: functionRequest,
              contentType: false,
              cache: false,
              processData: false,
              data: sendData,
              success: function (res) {
                var response = JSON.parse(res);
                var clientID = response.client.id;

                // Agency ID management
                // Tracker append in body in case of the modal do not exist after call
                if(
                  query.indexOf('agency-id=339852') !== -1 || query.indexOf('agency-id=348965') !== -1 || query.indexOf('agency-id=357986') !== -1 || query.indexOf('agency-id=365964') !== -1)
                {
                  $('body').append('<img src="//track.effiliation.com/servlet/effi.lead?id=660016950&ref='+clientID+'" alt="" width="1" height="1">');
                }

                if(query.indexOf('agency-id=353837') !== -1) {
                  $('body').append('<img src="//ext.ligatus.com/conversion/?c=153088&a=41882" width="1" height="1"/>');
                }

                if(query.indexOf('agency-id=346406') !== -1 || query.indexOf('agency-id=346407') !== -1) {
                  $('body').append('<img src="//tbl.tradedoubler.com/report?organization=2119684&event=363585&leadNumber='+email+'">');
                }

                if(query.indexOf('agency-id=355073') !== -1) {
                  _tfa.push({notify: 'event', name: 'Lead_Taboola', id: 1161679});
                }

                window.fireAgenciesTags();
              },
              error: function (error) {
                console.log(error);
              }
            });
          }
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);


  /* check if android keyboard up -- START */
  function onKeyboardOnOff(isOpen) {
    // Write down your handling code
    if (isOpen) {
      // keyboard is open
    } else {
      // keyboard is closed
    }
  }

  var originalPotion = false;
  $(document).ready(function(){
    if (originalPotion === false){
      originalPotion = $(window).width() + $(window).height();
    }
  });

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "winphone";
    }

    if (/android/i.test(userAgent)) {
      return "android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "ios";
    }

    return "";
  }

  function applyAfterResize() {

    if (getMobileOperatingSystem() !== 'ios') {
      if (originalPotion !== false) {
        var wasWithKeyboard = $('body').hasClass('view-withKeyboard');
        var nowWithKeyboard = false;

        var diff = Math.abs(originalPotion - ($(window).width() + $(window).height()));
        if (diff > 100) {
          nowWithKeyboard = true;
        }

        $('body').toggleClass('view-withKeyboard', nowWithKeyboard);
        if (wasWithKeyboard !== nowWithKeyboard) {
          onKeyboardOnOff(nowWithKeyboard);
        }
      }
    }
  }

  $(document).on('focus blur', '.mobileTop form .search input[name=s]', function(e){
    var $obj = $(this);
    var nowWithKeyboard = (e.type === 'focusin');
    $('body').toggleClass('view-withKeyboard', nowWithKeyboard);
    onKeyboardOnOff(nowWithKeyboard);
  });

  $(window).on('resize orientationchange', function(){
    if($('.mobileTop form .search input[name=s]').is(":focus")){
      applyAfterResize();
    }

  });



  /* check if android keyboard up -- END */

  /*$(window).load(function(){
    var WindowHeight = $(window).height();
    if($(window).width() < 991){
      setInterval(function() {
        console.log("bottom :" +$('#tawkchat-container iframe').css('bottom'));
        var styleTxt = $('#tawkchat-container iframe:first-child').attr("style");
        var sT = styleTxt.replace(/bottom\s*:\s*14px/, 'bottom : 50px');
        $('#tawkchat-container iframe:first-child')
          .css({
            'cssText': sT
          });

      }, 2000);

    }
  });*/



})(jQuery); // Fully reference jQuery after this point.

